export default __webpack_public_path__ + "static/media/travel-care-1.727a249a.svg";